import { TabBarFeatureConfigSchema, type TabBarFeatureConfig } from '@school-journey/shared-types'

import type { ScreenFeatureEntry } from './entry'

/**
 * Global `tabBar`. The one `systemScope` entry: the super-admin system page
 * edits the fleet default through `SYSTEM_DEFAULTS` (plan 02 U7).
 *
 * absentIsEmpty: an absent block is a valid state that mobile renders, so
 * not-found must not lock the panel. In production the fleet-default
 * GLOBAL_FEATURE_CONFIGS row carries `tabBar` and 20 of 33 school rows do too
 * (read-only production query, `SystemConfiguration`, 2026-10-02), so today it
 * only matters if a row loses the block.
 *
 * Fallback: `style: 'floating'`. Mobile renders the floating bar unless the
 * style is `classic` (`apps/mobile/src/context/hooks/use-tab-bar-style.ts:28-30`;
 * the `TabBarFeatureConfigSchema` docblock says the same).
 */
export const tabBar: ScreenFeatureEntry<'global', 'tabBar', TabBarFeatureConfig> & { systemScope: true } = {
  resource: 'global',
  wireName: 'tabBar',
  schema: TabBarFeatureConfigSchema,
  writeMode: 'replace',
  systemScope: true,
  absentIsEmpty: true,
  fallback: {
    style: 'floating'
  }
}
